import { useQuery } from '@tanstack/react-query';

import supabase from '../../../sdk/api';

const getData = async () => {
  const { data: userData } = await supabase.auth.getSession();

  if (!userData.session?.user.id) {
    return []
  }
  const { data, error } = await supabase
    .from('user_recent_queries')
    .select('*')
    .eq('user_id', userData.session?.user.id)
    .order('created_at', { ascending: false })
    .limit(20)
  if (error) {
    throw new Error();
  }

  const result = data.reduce((acc, item) => {
    if (acc.find((el) => el.query === item.query)) {
      return acc;
    } // @ts-ignore
    return [...acc, item];
  }, [])

  return result;
};

export default function useGetRecentQuerySuggestion() {
  return useQuery({
    queryKey: ['useGetRecentQuerySuggestion'],
    queryFn: () => getData(),
    staleTime: 0,
    cacheTime: 0,
  });
}
